var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPagerLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.506,
    height: 10,
    viewBox: "0 0 12.506 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pager-left",
    transform: "translate(761.256 1481) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-right",
    d: "M11.753,6l5,5-5,5L10.5,14.75,14.253,11,10.5,7.25Z",
    transform: "translate(738.25 1465)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-2",
    "data-name": "arrow-right",
    d: "M11.753,6l5,5-5,5L10.5,14.75,14.253,11,10.5,7.25Z",
    transform: "translate(744.503 1465)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagerLeft);
export default __webpack_public_path__ + "static/media/pager-left.e607265c10dc7cfe2870fcad7c2520c3.svg";
export { ForwardRef as ReactComponent };